import { creatorbase } from '@round/api';

export function getProjectCampaignsListParams(projectId: number, platform: creatorbase.Platform, pageSize: number) {
    return {
        project_id: projectId,
        platform,
        page_size: pageSize,
        ordering: 'project-platform-order',
    } as const;
}
